import React from "react";
import Logo from "./logo";
import "../styles/header.css";
const Header = () => {
  return (
    <header className="Header">
      <Logo />
    </header>
  );
};

export default Header;
